const MS_PER_SECOND = 1000;
const SECONDS_PER_MINUTE = 60;

/** A compact label — `4s`, `1m 05s` — clamping negatives from disagreeing clocks to zero. */
export function formatDuration(ms: number): string {
  const totalSeconds = Math.max(0, Math.floor(ms / MS_PER_SECOND));
  const minutes = Math.floor(totalSeconds / SECONDS_PER_MINUTE);
  const seconds = totalSeconds % SECONDS_PER_MINUTE;
  if (minutes === 0) return `${seconds}s`;
  return `${minutes}m ${String(seconds).padStart(2, '0')}s`;
}
